import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Demo from './pages/Demo'
import Home from './pages/Home'
import AnalyticsPage from './pages/Analytics';
import TeamMembers from './pages/TeamMembers';
import FaqManager from './pages/FaqManager';
import SharedChat from './pages/SharedChat';
import { ToastContainer } from 'react-toastify';
import MainLayout from './components/MainLayout';
import RequireAuth from './components/RequireAuth';
import RequireAdmin from './components/RequireAdmin';
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'

const RedirectWithQuery: React.FC<{ to: string }> = ({ to }) => {
    const location = useLocation();
    return <Navigate to={to + location.search} replace />;
};

export default function App() {
    return (
        <>
            <Tooltip id="my-tooltip" style={{
                backgroundColor: '#ffffff',          // cleaner than grey
                color: '#1f2937',
                padding: '10px 14px',
                borderRadius: '10px',
                fontSize: '13px',
                border: '1px solid #e5e7eb',
                boxShadow:
                    '0 10px 25px rgba(0,0,0,0.15), 0 2px 6px rgba(0,0,0,0.08)',
                zIndex: 9999,
            }} />
            <ToastContainer />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/demo" element={<RedirectWithQuery to="/chat" />} />
                <Route path="/shared/:token" element={<SharedChat />} />
                <Route element={<RequireAuth />}>
                    <Route element={<MainLayout />}>
                        <Route path="/chat" element={<Demo />} />
                        <Route element={<RequireAdmin />}>
                            <Route path="/analytics" element={<AnalyticsPage />} />
                            <Route path="/team_members" element={<TeamMembers />} />
                            <Route path="/faq_manager" element={<FaqManager />} />
                        </Route>
                    </Route>
                </Route>
            </Routes>
        </>
    )
}
